import { AnyAction } from "@reduxjs/toolkit";
import { setBalanceUpdate } from "redux/user/slice";
import {
  addReferral,
  deleteReferral,
  updateReferral,
} from "redux/referral/slice";
import { NotificationItem } from "types/Notifications";

export enum WebSocketEvent {
  BALANCE_UPDATE = "WS_BALANCE_UPDATE",
  REFERRAL_ADDED = "WS_REFERRAL_ADDED",
  REFERRALS_UPDATE = "WS_REFERRALS_UPDATE",
  REFERRAL_DELETED = "WS_REFERRAL_DELETED",
  POPUP_TRIGGERED = "WS_POPUP_TRIGGERED",
}

export const DELIVERABLE_EVENTS = new Set<string>(
  Object.values(WebSocketEvent),
);

export const getSocketEventHandler = (
  event: string,
  dispatch: (action: AnyAction) => void,
  addNotification: (notification: NotificationItem) => void,
): ((payload: any) => void) | undefined => {
  switch (event) {
    case WebSocketEvent.BALANCE_UPDATE:
      return (payload) =>
        dispatch(
          setBalanceUpdate({
            ...payload,
            balance: payload.balance,
            bonusBalance: payload.bonusBalance,
            referrerBalance: payload.referrerBalance,
          }),
        );

    case WebSocketEvent.REFERRAL_ADDED:
      return (payload) => dispatch(addReferral(payload));

    case WebSocketEvent.REFERRALS_UPDATE:
      return (payload) => dispatch(updateReferral(payload));

    case WebSocketEvent.REFERRAL_DELETED:
      return (payload) => dispatch(deleteReferral(Number(payload.referralId)));

    case WebSocketEvent.POPUP_TRIGGERED:
      return (payload) => payload && addNotification(payload);

    default:
      return undefined;
  }
};
